<div class="ch-panels workspace" *ngIf="current_company != null">
  <!-- Client Tasks -->
  <div
    class="ch-panel ch-shaded-panel ch-panel-tracked-items"
    [ngClass]="{ 'panel-hidden': isPanelClientTasksHidden }"
  >
    <div class="ch-panel-title">
      <div class="toggle-panel" (click)="togglePanel('clientTasks')">
        <i class="feather minus ch-panel-icon-title"></i> Client Tasks
        <!-- <div class="workspaces-badges"
                                        *ngIf="current_company['company_conversation'] !== undefined && countOpenTrackedItems(current_company['company_conversation'].tracked_items) > 0">
                                        <div class="badge-tracked-items">
                                            <span
                                                class="badge-counter">{{current_company['company_conversation'].open_tracked_items_count}}</span>
                                        </div>
                                    </div> -->
      </div>
      <div class="view-type d-flex">
        <span
          class="dropdown dropdown-archived-conversations"
          *ngIf="
            current_company != null &&
            (current_company['has_qbd'] || current_company['has_xero']) &&
            data.user_type == 1
          "
          dropdown
          [autoClose]="true"
        >
          <span
            id="dLabel"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            dropdownToggle
          >
            <i class="feather more-horizontal"></i>
          </span>
          <ul
            class="dropdown-menu dropdown-menu-end"
            *dropdownMenu
            aria-labelledby="dLabel"
          >
            <!-- <li class="dropdown-header">SNOOZE NOTIFICATIONS</li>
            <li><a>4 hours</a></li>
            <li><a>1 day</a></li>
            <li><a>1 week</a></li>
            <li role="separator" class="divider"></li> -->
            <li *ngIf="current_company['has_qbd']" class="dropdown-header">
              QuickBooks Integration
            </li>
            <!-- <li
              *ngIf="current_company['has_qbd']"
              (click)="checkNewQBOTransactions()"
            >
              <a>Check for new transactions</a>
            </li> -->

            <li
              *ngIf="current_company['has_qbd']"
              (click)="syncQBOTransactions()"
            >
              <a>Sync transactions from last 90 days</a>
            </li>
            <li *ngIf="current_company['has_xero']" class="dropdown-header">
              Xero Integration
            </li>
            <li
              *ngIf="current_company['has_xero']"
              (click)="checkNewXeroTransactions()"
            >
              <a>Check for new transactions</a>
            </li>
          </ul>
        </span>
      </div>
    </div>
    <app-tracked-items-panel
      chPaidOverlay
      [ctaText]="
        'Get client responses quickly and never wait for answers again'
      "
      [ctaVideo]="'https://youtu.be/NA35FeY7pNg'"
      class="ch-panel-content-wrapper ch-panel-component"
      [ngClass]="{
        list: tracked_view_type == 'list',
        'component-loading': loadings['tracked_items'],
      }"
      [company]="current_company"
      [conversation]="current_company?.company_conversation"
    >
    </app-tracked-items-panel>
  </div>

  <!-- Conversations -->
  <div
    class="ch-panel ch-shaded-panel ch-panel-conversations"
    [ngClass]="{ 'panel-hidden': isPanelConversationHidden }"
  >
    <div class="ch-panel-title">
      <div class="toggle-panel" (click)="togglePanel('conversation')">
        <i class="feather minus ch-panel-icon-title"></i> Conversation
        <!-- <span class="snoozed">Z</span> -->
        <!-- Conversation badge -->
        <!-- <div class="workspaces-badges">
                                        <div class="badge-messages"
                                            *ngIf="current_company['company_conversation'] !== undefined && !current_company['company_conversation'].read">
                                            <span class="badge-counter">&nbsp;</span>
                                        </div>
                                    </div> -->
      </div>
      <div class="view-type d-flex">
        <i class="feather search" (click)="toggleSearchMode()"></i>
        <i
          *ngIf="sharedDataService.data.user_type == 1 && pinnedCount > 0"
          class="tio-pin"
          [ngClass]="{
            'padding-left-pinned': pinnedCount > 0,
            active: pinnedMessagesActive,
          }"
          (click)="togglePinMode()"
        >
          <span class="pinned-count">{{ pinnedCount }}</span></i
        >

        <pin-filter
          (filterChanged)="changeMessagesFilter($event)"
          style="margin-right: 5px"
          class="hide-panel-hidden"
        ></pin-filter>

        <span
          class="dropdown-archived-conversations"
          *ngIf="current_company != null"
          dropdown
          [autoClose]="true"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <span dropdownToggle>
            <i class="feather more-horizontal"></i>
          </span>
          <ul class="dropdown-menu dropdown-menu-end" *dropdownMenu>
            <li class="dropdown-header">SYSTEM BOT SETTINGS</li>

            <li
              (click)="
                toggleBotMessages(
                  current_company['company_conversation'].options
                    .show_bot_messages
                )
              "
            >
              <a
                *ngIf="
                  current_company['company_conversation']?.options
                    ?.show_bot_messages
                "
                >Hide System Bot messages</a
              >
              <a
                *ngIf="
                  !current_company['company_conversation']?.options
                    ?.show_bot_messages
                "
                >Show System Bot messages</a
              >
            </li>
          </ul>
        </span>
      </div>
    </div>
    <!-- Conversations -->
    <app-chat-panel
      class="ch-panel-content-wrapper ch-panel-component"
      [ngClass]="{ 'component-loading': current_company?.loading }"
    >
    </app-chat-panel>
  </div>

  <!-- Links -->
  <div
    class="ch-panel ch-panel-links ch-shaded-panel links-panel"
    [ngClass]="{ 'panel-hidden': isPanelLinksHidden }"
  >
    <div class="ch-panel-title">
      <div class="toggle-panel" (click)="togglePanel('links')">
        <i class="feather minus ch-panel-icon-title"></i> Links
      </div>
    </div>
    <div class="ch-panel-content-wrapper ch-panel-component">
      <div class="ch-panel-content-scrollable-wrapper">
        <div class="ch-panel-content-scrollable">
          <app-easy-upload
            [conversation]="current_company?.company_conversation"
          />
          <!-- <app-huddle-widget
            [workspace]="current_company"
            *ngIf="isHuddleAvailable"
          ></app-huddle-widget> -->
          <app-apps-panel-widget
            *ngIf="current_company?.apps?.length > 0 || data.user_type == 1"
            [company]="current_company"
            [apps]="current_company?.apps"
          >
          </app-apps-panel-widget>
          <app-resources-panel-widget
            *ngIf="
              current_company?.resources?.length > 0 || data.user_type == 1
            "
            [company]="current_company"
            [resources]="current_company?.resources"
            class="resources-client-widget"
          >
          </app-resources-panel-widget>
          <!-- Reviews Widget -->
          <div
            class="panel panel-default reviews-widget"
            *ngIf="data?.user_type == 2 && hasAnyReviewSet()"
          >
            <div class="panel-heading">
              <h3>Leave a review</h3>
            </div>
            <div class="panel-body">
              <div
                class="review-item"
                *ngIf="
                  company.accounting_company.review_linkedin != '' &&
                  company.accounting_company.review_linkedin != null
                "
              >
                <a
                  href="{{ company.accounting_company.review_linkedin }}"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <img src="assets/img/reviews/linkedin.png" alt="LinkedIn" />
                </a>
              </div>
              <div
                class="review-item"
                *ngIf="
                  company.accounting_company.review_xero != '' &&
                  company.accounting_company.review_xero != null
                "
              >
                <a
                  href="{{ company.accounting_company.review_xero }}"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <img src="assets/img/reviews/xero.png" alt="Xero" />
                </a>
              </div>
              <div
                class="review-item"
                *ngIf="
                  company.accounting_company.review_proadvisor != '' &&
                  company.accounting_company.review_proadvisor != null
                "
              >
                <a
                  href="{{ company.accounting_company.review_proadvisor }}"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <img
                    src="assets/img/reviews/proadvisor.png"
                    alt="ProAdvisor"
                  />
                </a>
              </div>
              <div
                class="review-item"
                *ngIf="
                  company.accounting_company.review_google != '' &&
                  company.accounting_company.review_google != null
                "
              >
                <a
                  href="{{ company.accounting_company.review_google }}"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <img src="assets/img/reviews/google.png" alt="Google" />
                </a>
              </div>
            </div>
          </div>
          <!-- End of reviews widget -->
        </div>
      </div>
    </div>
  </div>
</div>
